export function addProtocol(url: string, protocol: 'https' | 'http' = 'https') {
    if (typeof url !== 'string' || /^(https?)?:\/\//.test(url)) {
        return url;
    }

    return `${protocol}://${url}`;
}
